import React from "react";
import { useField } from "formik";
import { Dropdown, IDropdownOption, TextField, IMessageBarStyles, MessageBar, MessageBarType, ITextFieldStyles } from "office-ui-fabric-react";
import { textFieldS } from "../../styles/edditionField.styles";

export const PHONE_PREFIXES: IDropdownOption[] = [
  { key: "+48", text: "+48 (PL)" },
  { key: "+49", text: "+49 (DE)" },
  { key: "+420", text: "+420 (CZ)" },
  { key: "+421", text: "+421 (SK)" },
  { key: "+372", text: "+372 (ET)" },
];

export const ADMIN_PHONE_PREFIXES: IDropdownOption[] = [
  { key: "+48", text: "+48 (PL)" },
  { key: "+370", text: "+370 (LT)" },
];

export const LANG_TO_PREFIX: Record<string, string> = {
  pl: "+48",
  de: "+49",
  sk: "+421",
  et: "+372",
  cs: "+420",
  lt: "+370",
};

export const splitStoredPhone = (phone: string, language: string): { prefix: string; number: string } => {
  const sortedPrefixes = PHONE_PREFIXES.map(p => p.key as string).sort((a, b) => b.length - a.length);
  for (const p of sortedPrefixes) {
    if (phone && phone.startsWith(p)) {
      return { prefix: p, number: phone.slice(p.length) };
    }
  }
  return { prefix: LANG_TO_PREFIX[language] || "+48", number: phone || "" };
};

const errorMessageS: IMessageBarStyles = {
  root: { marginTop: "15px", width: "100%" },
};

interface PhonePrefixFieldProps {
  prefixName: string;
  numberName: string;
  label: string;
  required?: boolean;
  prefixOptions?: IDropdownOption[];
  textStyles?: Partial<ITextFieldStyles>;
}

const PhonePrefixField: React.FC<PhonePrefixFieldProps> = ({
  prefixName, numberName, label, required,
  prefixOptions = PHONE_PREFIXES,
  textStyles = textFieldS,
}) => {
  const [, { value: prefixValue }, { setValue: setPrefix }] = useField(prefixName);
  const [numberField, { value: numberValue, error, touched }] = useField(numberName);

  return (
    <div>
      <div style={{ display: "flex", gap: "8px", alignItems: "flex-end" }}>
        <div style={{ width: "130px", flexShrink: 0 }}>
          <Dropdown
            label={label}
            options={prefixOptions}
            selectedKey={prefixValue}
            onChange={(_, option) => option && setPrefix(option.key)}
            required={required}
          />
        </div>
        <div style={{ flex: 1 }}>
          <TextField
            styles={textStyles}
            {...numberField}
            value={numberValue}
            errorMessage={touched ? error : ""}
          />
        </div>
      </div>
      {touched && error && (
        <MessageBar messageBarType={MessageBarType.error} isMultiline={false} styles={errorMessageS}>
          {error}
        </MessageBar>
      )}
    </div>
  );
};

export default PhonePrefixField;
